var path = 'app/reporting/site_specific/viewVisitors.html';
var html = "<div ng-include=\"'app/reporting/shared/reportsViewersVisitorsList.html'\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;